// Imports & Exports tool — material master (SAMPLE), container rules and the calculations.
// Everything a planner might want to change sits at the top of this file.

// ── 1. Material master — SAMPLE DATA ─────────────────────────────────────────────
// Illustrative values only (codes, HS codes, carton sizes, weights and prices are not
// Hasbro master data). Replace with the real material master before using the
// documents for customs.
export const SAMPLE_MATERIALS = [
    { code: "SMP-1001", description: "Monopoly Classic board game", hs: "9504.90.00", unitsPerCarton: 6, ctnCm: [52, 27, 28], netKgCtn: 6.9, grossKgCtn: 7.8, unitValue: 12.5 },
    { code: "SMP-1002", description: "Cluedo board game", hs: "9504.90.00", unitsPerCarton: 6, ctnCm: [42, 27, 28], netKgCtn: 5.4, grossKgCtn: 6.1, unitValue: 11.0 },
    { code: "SMP-1003", description: "Connect 4 game", hs: "9504.90.00", unitsPerCarton: 6, ctnCm: [40, 27, 32], netKgCtn: 4.8, grossKgCtn: 5.5, unitValue: 8.5 },
    { code: "SMP-1004", description: "Jenga classic game", hs: "9504.90.00", unitsPerCarton: 12, ctnCm: [38, 30, 28], netKgCtn: 10.2, grossKgCtn: 11.0, unitValue: 7.0 },
    { code: "SMP-1005", description: "Guess Who? game", hs: "9504.90.00", unitsPerCarton: 6, ctnCm: [42, 27, 30], netKgCtn: 4.2, grossKgCtn: 4.9, unitValue: 9.0 },
    { code: "SMP-1006", description: "Twister party game", hs: "9504.90.00", unitsPerCarton: 6, ctnCm: [42, 27, 30], netKgCtn: 4.5, grossKgCtn: 5.2, unitValue: 9.5 },
    { code: "SMP-2001", description: "Play-Doh 10-pack modelling compound", hs: "3407.00.00", unitsPerCarton: 12, ctnCm: [45, 32, 25], netKgCtn: 8.4, grossKgCtn: 9.3, unitValue: 6.0 },
    { code: "SMP-2002", description: "Play-Doh Kitchen Creations playset", hs: "9503.00.90", unitsPerCarton: 4, ctnCm: [50, 30, 36], netKgCtn: 4.1, grossKgCtn: 5.0, unitValue: 14.0 },
    { code: "SMP-3001", description: "Nerf Elite 2.0 blaster", hs: "9503.00.90", unitsPerCarton: 4, ctnCm: [62, 36, 30], netKgCtn: 4.0, grossKgCtn: 5.1, unitValue: 16.0 },
    { code: "SMP-3002", description: "Nerf foam darts refill 50-pack", hs: "9503.00.90", unitsPerCarton: 24, ctnCm: [48, 33, 30], netKgCtn: 5.3, grossKgCtn: 6.0, unitValue: 4.5 },
    { code: "SMP-4001", description: "Transformers action figure", hs: "9503.00.90", unitsPerCarton: 8, ctnCm: [46, 30, 26], netKgCtn: 3.3, grossKgCtn: 4.0, unitValue: 10.0 },
    { code: "SMP-4002", description: "Peppa Pig figure set", hs: "9503.00.90", unitsPerCarton: 12, ctnCm: [40, 30, 24], netKgCtn: 3.6, grossKgCtn: 4.2, unitValue: 5.5 },
    { code: "SMP-4003", description: "Baby Alive doll", hs: "9503.00.21", unitsPerCarton: 4, ctnCm: [54, 32, 36], netKgCtn: 4.4, grossKgCtn: 5.3, unitValue: 15.0 },
    { code: "SMP-5001", description: "Magic: The Gathering booster display", hs: "9504.40.00", unitsPerCarton: 6, ctnCm: [36, 24, 22], netKgCtn: 6.0, grossKgCtn: 6.7, unitValue: 75.0 },
];

// ── 2. Container rules ───────────────────────────────────────────────────────────
// Loadable cbm is what is practical to fill with cartons (internal volume is higher).
// The tool keeps BUFFER_CBM spare: a load fits a container if cbm ≤ loadable − buffer.
export const BUFFER_CBM = 1;
export const LCL_MAX_CBM = 15;          // below this a shared (LCL) container is usually cheaper
export const PALLET_CBM = 1.6;          // AU pallet 1.165 × 1.165 m, ~1.2 m high
export const CONTAINERS = {
    "20GP": { id: "20GP", label: "20ft container", internalCbm: 33.2, loadableCbm: 28, maxPayloadKg: 21600, lengthM: 6.06 },
    "40GP": { id: "40GP", label: "40ft container", internalCbm: 67.7, loadableCbm: 58, maxPayloadKg: 26500, lengthM: 12.19 },
};
export const INCOTERMS = ["EXW", "FCA", "FOB", "CFR", "CIF", "CPT", "CIP", "DAP", "DPU", "DDP"];
export const CURRENCIES = ["USD", "AUD", "NZD", "EUR", "GBP", "CNY", "HKD"];

// ── 3. Paste → rows ──────────────────────────────────────────────────────────────
const round = (n, dp = 3) => Math.round((Number(n) || 0) * 10 ** dp) / 10 ** dp;
const num = v => { const n = parseFloat(String(v ?? "").replace(/,/g, "")); return Number.isFinite(n) ? n : null; };
let seq = 0;
export const newId = () => `r${Date.now().toString(36)}${(seq++).toString(36)}`;

/** A row from the master (or blank values for a material that isn't in it) */
export function rowFor({ code, qty, description }, master = SAMPLE_MATERIALS) {
    const key = String(code || "").trim().toUpperCase();
    const desc = String(description || "").trim();
    const m = master.find(x => x.code.toUpperCase() === key)
        || (desc && !key ? master.find(x => x.description.toLowerCase() === desc.toLowerCase()) : null);
    const [l, w, h] = m?.ctnCm || [null, null, null];
    return {
        id: newId(), code: m?.code || key, description: desc || m?.description || "", qty: Math.max(0, Math.round(qty || 0)),
        matched: !!m, hs: m?.hs || "", unitsPerCarton: m?.unitsPerCarton ?? null,
        cbmPerCarton: l && w && h ? round((l * w * h) / 1e6, 4) : null, ctnCm: m?.ctnCm || null,
        netKgCtn: m?.netKgCtn ?? null, grossKgCtn: m?.grossKgCtn ?? null, unitValue: m?.unitValue ?? null,
    };
}

/**
 * Pasted text → rows. Accepts Excel / sheet copies (tab separated) and "material / qty /
 * description" lines with commas, semicolons, slashes or pipes. Column order doesn't matter:
 * the number is the quantity, a code-like token is the material, the rest is the description.
 * A header line (no number) is skipped.
 */
export function parsePaste(text, master = SAMPLE_MATERIALS) {
    const codes = new Set(master.map(m => m.code.toUpperCase()));
    const rows = [], skipped = [];
    String(text || "").split(/\r?\n/).forEach((line, i) => {
        if (!line.trim()) return;
        // "2,400" is a thousands separator, not a column break
        const plain = line.includes("\t") ? line : line.replace(/(\d),(?=\d{3}(?!\d))/g, "$1");
        const cells = (line.includes("\t") ? line.split("\t") : plain.split(/\s*[,;|]\s*|\s+\/\s+/)).map(c => c.trim()).filter(Boolean);
        const qtyIdx = cells.findIndex(c => /^\d[\d,]*(\.\d+)?$/.test(c));
        if (qtyIdx < 0) { if (i > 0 || cells.length < 2) skipped.push(line.trim()); return; }
        const rest = cells.filter((_, k) => k !== qtyIdx);
        let codeIdx = rest.findIndex(c => codes.has(c.toUpperCase()));
        if (codeIdx < 0) codeIdx = rest.findIndex(c => /^[A-Z0-9][A-Z0-9-]{2,}$/i.test(c) && /\d/.test(c) && !/\s/.test(c));
        const code = codeIdx >= 0 ? rest[codeIdx] : "";
        const description = rest.filter((_, k) => k !== codeIdx).join(" ");
        rows.push(rowFor({ code, qty: num(cells[qtyIdx]), description }, master));
    });
    return { rows, skipped };
}

// ── 4. Calculations ──────────────────────────────────────────────────────────────
/** Per-line figures. Cartons round up; net weight is per unit, gross per (full) carton. */
export function lineCalc(r) {
    const units = r.unitsPerCarton > 0 ? r.unitsPerCarton : null;
    const cartons = units ? Math.ceil((r.qty || 0) / units) : null;
    const missing = [!r.hs && "HS code", !units && "units / carton", r.cbmPerCarton == null && "cbm / carton",
        r.grossKgCtn == null && "gross kg", r.netKgCtn == null && "net kg", r.unitValue == null && "unit value"].filter(Boolean);
    return {
        cartons,
        cbm: cartons != null && r.cbmPerCarton != null ? round(cartons * r.cbmPerCarton) : null,
        netKg: units && r.netKgCtn != null ? round(((r.qty || 0) * r.netKgCtn) / units, 2) : null,
        grossKg: cartons != null && r.grossKgCtn != null ? round(cartons * r.grossKgCtn, 2) : null,
        value: r.unitValue != null ? round((r.qty || 0) * r.unitValue, 2) : null,
        missing,
    };
}

export function totals(rows) {
    const t = { lines: rows.length, qty: 0, cartons: 0, cbm: 0, netKg: 0, grossKg: 0, value: 0, incomplete: 0 };
    for (const r of rows) {
        const c = lineCalc(r);
        t.qty += r.qty || 0; t.cartons += c.cartons || 0; t.cbm += c.cbm || 0;
        t.netKg += c.netKg || 0; t.grossKg += c.grossKg || 0; t.value += c.value || 0;
        if (c.missing.length) t.incomplete++;
    }
    return { ...t, cbm: round(t.cbm), netKg: round(t.netKg, 2), grossKg: round(t.grossKg, 2), value: round(t.value, 2), pallets: Math.ceil(t.cbm / PALLET_CBM) };
}

/** Totals by HS code — what the customs broker needs */
export function byHsCode(rows) {
    const m = new Map();
    for (const r of rows) {
        const c = lineCalc(r);
        const k = r.hs || "(no HS code)";
        const g = m.get(k) || { hs: k, lines: 0, qty: 0, cartons: 0, cbm: 0, netKg: 0, grossKg: 0, value: 0 };
        g.lines++; g.qty += r.qty || 0; g.cartons += c.cartons || 0; g.cbm += c.cbm || 0;
        g.netKg += c.netKg || 0; g.grossKg += c.grossKg || 0; g.value += c.value || 0;
        m.set(k, g);
    }
    return [...m.values()].map(g => ({ ...g, cbm: round(g.cbm), netKg: round(g.netKg, 2), grossKg: round(g.grossKg, 2), value: round(g.value, 2) }))
        .sort((a, b) => b.value - a.value);
}

// ── 5. Container recommendation ──────────────────────────────────────────────────
const fits = (c, cbm, kg) => cbm <= c.loadableCbm - BUFFER_CBM && kg <= c.maxPayloadKg;

/** One load (≤ one 40ft) → "LCL" | "20GP" | "40GP" */
function single(cbm, kg) {
    if (cbm <= 0) return null;
    if (cbm < LCL_MAX_CBM && kg <= CONTAINERS["20GP"].maxPayloadKg) return "LCL";
    if (fits(CONTAINERS["20GP"], cbm, kg)) return "20GP";
    return "40GP";
}

/**
 * Recommendation for the total load, with the reason, plus how full each option would be.
 * Over one 40ft: as many full 40ft as needed, then the remainder on its own (LCL / 20ft / 40ft).
 */
export function recommend({ cbm, grossKg }) {
    const c20 = CONTAINERS["20GP"], c40 = CONTAINERS["40GP"];
    const options = {
        LCL: { fill: null, ok: cbm > 0 && cbm < LCL_MAX_CBM, note: `Under ${LCL_MAX_CBM} cbm — share a container, pay per cbm` },
        "20GP": { fill: cbm / c20.loadableCbm, ok: fits(c20, cbm, grossKg), note: `Up to ${c20.loadableCbm - BUFFER_CBM} cbm (${c20.loadableCbm} − ${BUFFER_CBM} buffer) · ${c20.maxPayloadKg.toLocaleString()} kg` },
        "40GP": { fill: cbm / c40.loadableCbm, ok: fits(c40, cbm, grossKg), note: `Up to ${c40.loadableCbm - BUFFER_CBM} cbm (${c40.loadableCbm} − ${BUFFER_CBM} buffer) · ${c40.maxPayloadKg.toLocaleString()} kg` },
    };
    if (!(cbm > 0)) return { pick: null, mix: [], reason: "Paste materials to see the best container.", options };

    const mix = [];
    let restCbm = cbm, restKg = grossKg;
    const per40 = c40.loadableCbm - BUFFER_CBM;
    while (restCbm > per40 || restKg > c40.maxPayloadKg) {
        mix.push("40GP");
        const share = Math.min(1, per40 / restCbm);
        restKg -= restKg * share;
        restCbm -= per40;
    }
    const last = single(restCbm, restKg);
    if (last) mix.push(last);
    const pick = mix.length === 1 ? mix[0] : "MIX";
    const label = { LCL: "LCL (shared container)", "20GP": "20ft container", "40GP": "40ft container" };
    const counts = mix.reduce((a, k) => ({ ...a, [k]: (a[k] || 0) + 1 }), {});
    const mixText = Object.entries(counts).map(([k, n]) => `${n} × ${label[k]}`).join(" + ");
    const reason = pick === "LCL" ? `${round(cbm, 2)} cbm is under ${LCL_MAX_CBM} cbm — a full container would mostly be empty air.`
        : pick === "20GP" ? `${round(cbm, 2)} cbm fits a 20ft with at least ${BUFFER_CBM} cbm to spare (${Math.round((cbm / c20.loadableCbm) * 100)}% full).`
        : pick === "40GP" ? (cbm <= c20.loadableCbm - BUFFER_CBM
            ? `${Math.round(grossKg).toLocaleString()} kg is over a 20ft's ${c20.maxPayloadKg.toLocaleString()} kg limit — a 40ft takes the weight (${Math.round((cbm / c40.loadableCbm) * 100)}% full by volume).`
            : `${round(cbm, 2)} cbm is more than a 20ft takes with the ${BUFFER_CBM} cbm buffer — a 40ft is ${Math.round((cbm / c40.loadableCbm) * 100)}% full.`)
        : `${round(cbm, 2)} cbm is more than one 40ft takes — ${mixText}.`;
    return { pick, mix, mixText, reason, options };
}
